// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"styles_modalContainer__VVMEE","confirmText":"styles_confirmText__7gEVE","yesBtn":"styles_yesBtn__sVliW","noBtn":"styles_noBtn__Ug_kL"};